export default __webpack_public_path__ + "static/media/gallery-wip-clamp-lever_00.44a0f156.jpg";